import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    getJobDetails,
    getJobtemplateconfig,
    getQuestionList,
} from "../../../../redux/slices/careersSlices.reducer";
import { publishingDate } from "../CareersFucConfig";
import Model from "../../../../component/modal/Modal";
import Image from "../../../../component/image/Image";
import useClientConfig from "../../../../config/careers/clientConfig";
import OptionSixJobView from "./OptionSixJobView";

const OptionSixJobViewPage = (props: any) => {
    const { jobDataView, navigateToJob, getListOfJob } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const routeParams = useParams();
    const routerLocation = useLocation();
    const jobDetails = useSelector((state: any) => state.careers.jobDetails);
    const questionId = useSelector((state: any) => state.careers.getQuestionId);
    const [jobModel, setJobModel] = useState(false);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const similarJobList = jobDetails?.data?.data?.job?.similarJobs;
    const languageSettings = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const jobViewLangLabels = languageSettings?.jobView?.[0];
    const jobListingLangLabels = languageSettings?.jobListing?.[0];
    const { clientSiteSettings } = useClientConfig();
    const hiddenSections: string[] = clientSiteSettings?.optionSixSettings?.hiddenJobViewSections || [];
    const show = (key: string) => !hiddenSections.includes(key);

    useEffect(() => {
        if (!routerLocation.pathname.includes("/apply-job/")) {
            document.body.classList.add("view-job-page");
            document.body.classList.remove("career-page");
            document.body.classList.remove("apply-job-page");
        }
    }, []);

    useEffect(() => {
        if (routerLocation.pathname === `/view/${routeParams?.id}`) {
            dispatch<any>(getJobtemplateconfig(cliendConfig?.data?.data?.clientSettings?.clientId));
            if (Object.keys(questionId).length === 0) {
                dispatch<any>(getQuestionList());
            }
        }
    }, []);

    useEffect(() => {
        if (routerLocation.pathname === `/view/${routeParams?.id}/apply-job/from/${routeParams?.from}`) {
            dispatch<any>(getJobDetails(routeParams?.id));
        }
    }, [routeParams?.id]);

    useEffect(() => {
        if (
            jobDetails?.data?.statusCode === 200 &&
            routerLocation?.pathname === `/view/${routeParams?.id}`
        ) {
            if (navigator.userAgent.indexOf("Firefox") !== -1) {
                setTimeout(() => window.scrollTo(0, 0), 1300);
            } else {
                window.scrollTo(0, 0);
            }
        }
    }, [routerLocation]);

    // ── Section render helpers ──────────────────────────────────────────────

    const titleSection = () => (
        <h1 className="opt6-view-title">
            {jobDetails?.data?.data?.job?.title}
        </h1>
    );

    const description = () => (
        <div
            className="opt6-view-description"
            dangerouslySetInnerHTML={{ __html: jobDetails?.data?.data?.job?.description }}
        />
    );

    const listOfPoint = () => {
        if (!show("listOfPoint")) {return null;}
        const { bulletPoint1, bulletPoint2, bulletPoint3 } = jobDetails?.data?.data?.job || {};
        if (!bulletPoint1 && !bulletPoint2 && !bulletPoint3) {return null;}
        return (
            <ul className="opt6-view-bullets">
                {bulletPoint1 && <li>{bulletPoint1}</li>}
                {bulletPoint2 && <li>{bulletPoint2}</li>}
                {bulletPoint3 && <li>{bulletPoint3}</li>}
            </ul>
        );
    };

    const imgAndVideo = () => {
        if (!show("imgAndVideo")) {return null;}
        const { videoLink, imageLink } = jobDetails?.data?.data?.job || {};
        if (!videoLink && !imageLink) {return null;}
        return (
            <div className="opt6-view-media">
                {videoLink ? (
                    <iframe
                        width="100%"
                        height="315"
                        src={videoLink}
                        title="Job Video"
                        frameBorder="0"
                        allowFullScreen
                    />
                ) : (
                    <img src={imageLink} alt="Job" />
                )}
            </div>
        );
    };

    const jobLogo = () => {
        if (!show("jobLogo")) {return null;}
        const src = jobDetails?.data?.data?.job?.logo || null;
        // const src = jobDetails?.data?.data?.job?.logo || cliendConfig?.data?.data?.clientSettings?.logo;
        if (!src) {return null;}
        return <Image src={src} width={80} alt="logo" />;
    };

    const jobLocation = () => {
        if (!show("jobLocation")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-map-marker" />
                <span>
                    <strong>{jobListingLangLabels?.location || t("Location")}:</strong>{" "}
                    {jobDetails?.data?.data?.job?.location?.location}
                </span>
            </div>
        );
    };

    const category = () => {
        if (!show("category")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-folder" />
                <span>
                    <strong>{jobViewLangLabels?.category || t("Category")}:</strong>{" "}
                    {jobDetails?.data?.data?.job?.category}
                </span>
            </div>
        );
    };

    const positionType = () => {
        if (!show("positionType")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-user" />
                <span>
                    <strong>{jobViewLangLabels?.positionType || t("Position Type")}:</strong>{" "}
                    {jobDetails?.data?.data?.job?.jobType}
                </span>
            </div>
        );
    };

    const salary = () => {
        if (!show("salary")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-dollar" />
                <span>
                    <strong>{jobViewLangLabels?.salary || t("Salary")}:</strong>{" "}
                    {jobDetails?.data?.data?.job?.salary}
                </span>
            </div>
        );
    };

    const referenceNo = () => {
        if (!show("referenceNo")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-briefcase" />
                <span>
                    <strong>{jobViewLangLabels?.jobReference || t("Reference")}:</strong>{" "}
                    {jobDetails?.data?.data?.job?.referenceNo}
                </span>
            </div>
        );
    };

    const postedOn = () => {
        if (!show("postedOn")) {return null;}
        return (
            <div className="opt6-meta-item">
                <i className="pi pi-calendar" />
                <span>
                    <strong>{jobViewLangLabels?.posted || t("Posted")}:</strong>{" "}
                    {publishingDate(jobDetails?.data?.data?.job?.postedAt)}
                </span>
            </div>
        );
    };

    const positionFile = () => {
        if (!show("positionFile")) {return null;}
        const file = jobDetails?.data?.data?.job?.positionFile;
        if (!file) {return null;}
        return (
            <a className="opt6-position-file-link" href={file} download target="_blank" rel="noopener noreferrer">
                {t("View Position Description")}
            </a>
        );
    };

    const ApplyNowButton = () => {
        if (routerLocation.state === "jobApply") {return null;}
        return (
            <>
                <button
                    className="opt6-apply-btn"
                    onClick={() => navigate(`/view/${routeParams?.id}/apply-job/from/direct`)}
                >
                    {t(cliendConfig?.data?.data?.clientSettings?.applyButtonText) || t("Apply Now")}
                </button>
                {clientSiteSettings?.templateName === "template_12" && (
                    <button
                        className="opt6-back-btn"
                        onClick={() => {
                            localStorage.setItem("backtoresult", "1");
                            sessionStorage.setItem("backtoresult", "1");
                            getListOfJob();
                        }}
                    >
                        {jobViewLangLabels?.backToResults || t("Back to Results")}
                    </button>
                )}
            </>
        );
    };

    const searchControlFilter = () => setJobModel((prs) => !prs);

    const JobFilterBody = () => (
        <>
            <div className="model-close-icon">
                <i onClick={searchControlFilter} className="pi pi-times" />
            </div>
            {jobDataView}
        </>
    );

    // ── Render ──────────────────────────────────────────────────────────────

    if (jobDetails?.data?.statusCode === 400) {
        return (
            <div className="option6-jobs">
                <div className="option6-shell">
                    <div className="option6-card" style={{ textAlign: "center" }}>
                        {jobDetails?.data?.message}
                    </div>
                </div>
            </div>
        );
    }

    if (jobDetails.status !== 200 || jobDetails?.data?.statusCode !== 200) {
        return null;
    }

    return (
        <>
            <OptionSixJobView
                jobDataView={jobDataView}
                routerLocation={routerLocation}
                routeParams={routeParams}
                titleSection={titleSection}
                jobLogo={jobLogo}
                ApplyNowButton={ApplyNowButton}
                listOfPoint={listOfPoint}
                description={description}
                imgAndVideo={imgAndVideo}
                positionFile={positionFile}
                jobLocation={jobLocation}
                referenceNo={referenceNo}
                positionType={positionType}
                category={category}
                salary={salary}
                postedOn={postedOn}
                searchControlFilter={searchControlFilter}
                navigateToJob={navigateToJob}
                getListOfJob={getListOfJob}
                similarJobList={similarJobList}
                langSettings={languageSettings}
                clientSiteSettings={clientSiteSettings}
            />
            <Model show={jobModel} size="lg" modelBody={JobFilterBody()} />
        </>
    );
};

export default OptionSixJobViewPage;
